import Vue from 'vue';
import publicProfileTransformer from './../../transformers/publicProfile';
import find from './show';

// When the request succeeds
const success = (resolve) => {
  find();
  resolve();
};

// When the request fails
const failed = (error, reject) => {
  reject(publicProfileTransformer.fetch(error.response.data));
};

export default (publicProfile) => {
  const data = new FormData();
  Object.keys(publicProfile).map((k) => {
    data.append(k, publicProfile[k]);
    return null;
  });
  return new Promise((resolve, reject) => {
    Vue.$http
    .request({
      url: 'public_profile',
      data,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(() => {
      success(resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  });
};



// WEBPACK FOOTER //
// ./src/app/services/publicProfile/update.js